import React from 'react';
import styled from 'styled-components';
import Spacer from '../Layout/Spacer';

const SectionContainer = styled.section``;

export const SectionHeader = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxl};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  line-height: 2.5;
`;
const SectionBody = styled.p`
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: 1.5;
`;

export interface ISection {
  header: string;
}

const Section: React.FC<ISection> = ({ header, children }) => {
  return (
    <SectionContainer>
      <SectionHeader>{header}</SectionHeader>
      <Spacer height="1rem"></Spacer>
      <SectionBody>{children}</SectionBody>
    </SectionContainer>
  );
};

export { Section };
